export const brand1Gradient = '#fff';
export const brand2Gradient = 'linear-gradient(238.51deg,#407A7D 32.13%,#4D9296 72.23%)';
export const brand3Gradient = 'linear-gradient(180deg,#06444D 0%,#0B5965 0.01%,#06444D 100%)';
export const brand4Gradient = 'linear-gradient(180deg,#2B3D58 0%,#151F2E 100%)';
export const brand4Misc = 'linear-gradient(174.11deg,#D6DBD5 3.46%,rgba(245,247,245,0.2) 95.98%)';
